/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getRewards} from '../api'

 export const useQueryGetRewards = createReactQueryHook('getRewards', getRewards)
